import {
	SET_REVIEWS_FILTERS,
	UPDATE_RATING_FILTER,
	UPDATE_MODEL_FILTER,
	UPDATE_TYPE_FILTER
} from '../actions/types';

const initialState = {
	ratings: [],
	models: [],
	types: {
		selected: 'overall'
	}
};

export default function reviewFilters(state = initialState, action) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case SET_REVIEWS_FILTERS:
				return action.payload;
			case UPDATE_RATING_FILTER:
				return {
					...state,
					ratings: {
						...state.ratings,
						[action.payload.rating]: action.payload.checked
					}
				};
			case UPDATE_MODEL_FILTER:
				return {
					...state,
					models: {
						...state.models,
						[action.payload.model]: action.payload.checked
					}
				};
			case UPDATE_TYPE_FILTER:
				return {
					...state,
					types: {
						...state.types,
						selected: action.payload
					}
				};
			// no default
		}
	}

	return state;
}
